
import * as ConfigTypes from 'config/ConfigTypes';
import { isLocal, pubPath } from "helpers/AppHelper";
import { getDefaultImg } from 'helpers/FileHelper';

export const getThumbUrl = ({ item, fullScreen }) => {
    let width = ConfigTypes.IMG_WIDTH;
    let height = ConfigTypes.IMG_HEIGHT;
    if (fullScreen) {
        width = ConfigTypes.FULL_WIDTH;
        height = ConfigTypes.FULL_HEIGHT;
    }
    let origin = window.location.origin;
    if (isLocal()) origin = ConfigTypes.DEMO_SERVER;
    return `${origin}/mfc/thumbnail.cgi?file=${item.path}${item.filename}&width=${width}&height=${height}`;
}

export const getWidthHeight = ({ stateCurrentClip, props }) => {
    let width = ConfigTypes.IMG_WIDTH;
    let height = ConfigTypes.IMG_HEIGHT;
    if (stateCurrentClip
        && stateCurrentClip.mainthumbnail
        && stateCurrentClip.mainthumbnail.url) {
        const filename = stateCurrentClip.mainthumbnail.filename;
        const { currentClip } = props.mediaObjects;
        if (currentClip && currentClip.mediafiles
            && currentClip.mediafiles.elements && currentClip.mediafiles.elements.length > 0) {
            let found = currentClip.mediafiles.elements.find(item => (item.path + item.filename) === filename);
            if (found.width && found.height) {
                width = (found.width * height) / found.height;
            }
        }
    }
    return { width, height }
}


export const getImgUrl = ({ fullScreen = false, stateCurrentClip }) => {
    let width = ConfigTypes.IMG_WIDTH;
    let height = ConfigTypes.IMG_HEIGHT;
    if (fullScreen) {
        width = ConfigTypes.FULL_WIDTH;
        height = ConfigTypes.FULL_HEIGHT;
    }
    if (stateCurrentClip
        && stateCurrentClip.mainthumbnail
        && stateCurrentClip.mainthumbnail.url) {
        return `${stateCurrentClip.mainthumbnail.url}&width=${width}&height=${height}`;
    }

    if (stateCurrentClip
        && stateCurrentClip.metadata
        && stateCurrentClip.metadata.fields
        && stateCurrentClip.metadata.fields.thumbnail) {

        return stateCurrentClip.metadata.fields.thumbnail;
    }
    return getDefaultImg();
}

